<script setup lang="ts">
import '@/assets/styles/legal.css'
</script>

<template>
  <div class="legal-page">
    <section class="legal-card">
      <h1>Impressum</h1>

      <h2>Angaben gemäß § 5 TMG</h2>
      <p>
        Gallus Pflegedienst e.K.<br/>
        Inhaber: Mileva Markovic<br/>
        Am Niedwald 53<br/>
        65933 Frankfurt am Main
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: 06975009899<br/>
        E-Mail: info@galluspflegedienst.de
      </p>

      <h2>Aufsichtsbehörde</h2>
      <p>
        Gesundheitsamt Frankfurt am Main<br/>
        Breite G. 28<br/>
        60313 Frankfurt am Main<br/>
      </p>

      <h2>Berufsbezeichnung</h2>
      <p>
        Pflegefachkraft (verliehen in der Bundesrepublik Deutschland)
      </p>

      <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
      <p>
        Gallus Pflegedienst e.K.<br/>
        Inhaber: Mileva Markovic<br/>
        Am Niedwald 53<br/>
        65933 Frankfurt am Main
      </p>

      <h2>Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf
        diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
        Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet, übermittelte
        oder gespeicherte fremde Informationen zu überwachen.
      </p>

      <h2>Haftung für Links</h2>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte übernehmen
        wir keine Gewähr.
      </p>

      <h2>Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht.
        Beiträge Dritter sind als solche gekennzeichnet.
      </p>
    </section>
  </div>
</template>
